import { render, staticRenderFns } from "./softwareTable.vue?vue&type=template&id=7fc387c2"
import script from "./softwareTable.vue?vue&type=script&lang=js"
export * from "./softwareTable.vue?vue&type=script&lang=js"
import style0 from "./softwareTable.vue?vue&type=style&index=0&id=7fc387c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports